import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';

import {
  FormControl,
  Input,
  Select,
  MenuItem,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Button,
} from '@mui/material';

import { ModalPopup } from '../Elements/Modal';
import { ModalCompletionFormIcon } from '../Elements/ModalCompletionFormIcon';

import { SelectEmployerProgram } from '../SelectEmployerProgram/SelectEmployerProgram';

import {
  AREA_RATES_SEARCH,
  ZIP_CODE,
  STATE,
  STATE_OPTIONS,
  ATTEND_A_HOUSE_OF_WORSHIP,
  SEARCH_BY_EMPLOYMENT_AREA,
  SELECT_EMPLOYER_PROGRAMS,
  QUORUM_SEG_TITLE,
} from '../../constants/LoansCalculator';

import './AreaRatesSearch.css';

export const AreaRatesSearch = ({
  zipCode,
  onZipCodeChange,
  usState,
  onUsStateChange,
  houseOfWorshipZipCode,
  onHouseOfWorshipZipCodeChange,
  houseOfWorshipUsState,
  onHouseOfWorshipUsStateChange,
  employmentZipCode,
  onEmploymenZipCodeChange,
  employmentUsState,
  onEmploymentStateChange,
  filter,
  segsList,
  setSegsList,
  isQuorumEligible,
  setIsQuorumEligible,
}) => {
  const [showHouseWorshipArea, setHouseWorshipArea] = useState(false);
  const [showEmploymentArea, setEmploymentArea] = useState(false);

  const [isOpenSelectEmployer, setIsOpenSelectEmployer] = useState(false);

  const handleSelectEmployerProgram = () => {
    setIsOpenSelectEmployer(true);
    mixpanel.track(`Open Select Employer Group ${filter}`, {
      SEG: segsList,
      isQuorumEligible,
      action: 'open',
    });
  };

  const handleConfirmEligible = (val, segs) => {
    setIsQuorumEligible(val);
    setIsOpenSelectEmployer(false);

    mixpanel.track(`Confirm Eligible Select Employer Group ${filter}`, {
      SEG: segs,
      isQuorumEligible: val,
    });
    setSegsList(segs);
  };

  return (
    <div className="area-rates-search-wrapper">
      <h3 className="area-rates-search-header">{AREA_RATES_SEARCH}</h3>

      <div className="area-rates-search-fields-row-wrapper">
        <div className="area-rates-search-zip-code-field-wrapper">
          <p className="zip-code-state-label">{ZIP_CODE}</p>
          <FormControl
            sx={{
              width: '100%',
            }}
          >
            <Input
              id="zip-code-financing-select-helper"
              value={zipCode}
              placeholder={ZIP_CODE}
              autoComplete="off"
              onChange={(e) => {
                if (!isNaN(e.target.value)) {
                  onZipCodeChange(e.target.value);
                }
              }}
              disableUnderline
            />
          </FormControl>
        </div>
        <div className="area-rates-search-state-field-wrapper">
          <p className="zip-code-state-label">{STATE}</p>
          <FormControl
            sx={{
              width: '100%',
            }}
          >
            <Select
              id="state-financing-select-helper"
              value={usState}
              onChange={(e) => {
                onUsStateChange(e.target.value);
              }}
            >
              {STATE_OPTIONS.map(({ value, text }) => (
                <MenuItem key={value} value={value}>
                  {text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>

      <FormGroup sx={{ mb: { xs: 1, md: 0 } }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={showHouseWorshipArea}
              onChange={(e) => {
                setHouseWorshipArea(e.target.checked);
                mixpanel.track(`Area Rates Search ${filter}`, {
                  checkbox: 'house of worship checkbox',
                  filter,
                  value: e.target.checked,
                });
              }}
            />
          }
          label={ATTEND_A_HOUSE_OF_WORSHIP}
        />
      </FormGroup>

      {showHouseWorshipArea && (
        <div className="area-rates-search-fields-row-wrapper">
          <div className="area-rates-search-zip-code-field-wrapper">
            <p className="zip-code-state-label">{ZIP_CODE}</p>
            <FormControl
              sx={{
                width: '100%',
              }}
            >
              <Input
                id="zip-code-financing-select-helper"
                value={houseOfWorshipZipCode}
                placeholder={ZIP_CODE}
                autoComplete="off"
                onChange={(e) => {
                  if (!isNaN(e.target.value)) {
                    onHouseOfWorshipZipCodeChange(e.target.value);
                  }
                }}
                disableUnderline
              />
            </FormControl>
          </div>
          <div className="area-rates-search-state-field-wrapper">
            <p className="zip-code-state-label">{STATE}</p>
            <FormControl
              sx={{
                width: '100%',
              }}
            >
              <Select
                id="state-financing-select-helper"
                value={houseOfWorshipUsState}
                onChange={(e) => {
                  onHouseOfWorshipUsStateChange(e.target.value);
                }}
              >
                {STATE_OPTIONS.map(({ value, text }) => (
                  <MenuItem key={value} value={value}>
                    {text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
      )}

      <FormGroup sx={{ mb: { xs: 0, md: 1 } }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={showEmploymentArea}
              onChange={(e) => {
                setEmploymentArea(e.target.checked);
                mixpanel.track(`Area Rates Search ${filter}`, {
                  checkbox: 'employment area checkbox',
                  filter,
                  value: e.target.checked,
                });
              }}
            />
          }
          label={SEARCH_BY_EMPLOYMENT_AREA}
        />
      </FormGroup>

      {showEmploymentArea && (
        <div>
          <div className="area-rates-search-fields-row-wrapper">
            <div className="area-rates-search-zip-code-field-wrapper">
              <p className="zip-code-state-label">{ZIP_CODE}</p>
              <FormControl
                sx={{
                  width: '100%',
                }}
              >
                <Input
                  id="zip-code-financing-select-helper"
                  value={employmentZipCode}
                  placeholder={ZIP_CODE}
                  autoComplete="off"
                  onChange={(e) => {
                    if (!isNaN(e.target.value)) {
                      onEmploymenZipCodeChange(e.target.value);
                    }
                  }}
                  disableUnderline
                />
              </FormControl>
            </div>
            <div className="area-rates-search-state-field-wrapper">
              <p className="zip-code-state-label">{STATE}</p>
              <FormControl
                sx={{
                  width: '100%',
                }}
              >
                <Select
                  id="state-financing-select-helper"
                  value={employmentUsState}
                  onChange={(e) => {
                    onEmploymentStateChange(e.target.value);
                  }}
                >
                  {STATE_OPTIONS.map(({ value, text }) => (
                    <MenuItem key={value} value={value}>
                      {text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
          <div>
            <ModalPopup
              buttonContent={
                <Button
                  variant="outlined"
                  sx={{
                    '&:hover': { backgroundColor: 'lightblue', color: 'black' },
                    borderRadius: '10px',
                    border: '1px solid gray',
                    height: '53px',
                    backgroundColor: 'white',
                    textTransform: 'initial',
                    color: 'black',
                    width: '100%',
                  }}
                >
                  {SELECT_EMPLOYER_PROGRAMS}
                  <ModalCompletionFormIcon isConfirmed={isQuorumEligible} />
                </Button>
              }
              modalContent={
                <SelectEmployerProgram
                  onConfirmEligible={handleConfirmEligible}
                  originalSegsList={segsList}
                  filter={filter}
                />
              }
              modalButtonId="select-employer-modal"
              title={QUORUM_SEG_TITLE}
              open={isOpenSelectEmployer}
              handleClose={() => {
                setIsOpenSelectEmployer(false);

                mixpanel.track(`Confirm Eligible Select Employer Group ${filter}`, {
                  action: 'close',
                });
              }}
              handleOpen={handleSelectEmployerProgram}
            />
          </div>
        </div>
      )}
    </div>
  );
};
